import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { FaEye, FaEdit, FaTrash, FaSearch, FaTimes, FaCalendar, FaExchangeAlt } from 'react-icons/fa';
import { useDispatch, useSelector } from "react-redux";
import { successToast, errorToast } from '../../Utils/toast';
import { openModal } from "../../redux/features/modalSlice";
import Pagination from '../../common/Pagination';
import SearchBar from '../../common/Search';
import { setState } from '../../redux/features/filtersSlice';
import { 
    useGetEventQuery, 
    useChangeStatusEventMutation,
    useDeleteEventMutation 
} from "../../redux/services/eventService/event.Services";
import CommonBreadcrumb from '../../common/CommonBreadcrumb';
function Events() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const filter = useSelector((state) => state.filters.state);
    const [statusFilter, setStatusFilter] = useState(filter.status || '');
    const [loadingId, setLoadingId] = useState(null);

    const { data, isLoading, isError, refetch } = useGetEventQuery(filter);
    const [changeStatus] = useChangeStatusEventMutation();
    const [deleteEvent] = useDeleteEventMutation();

    const eventData = data?.data || [];
    const pagination = data?.pagination || {};
    const totalPages = pagination?.totalPages || 0;
    const totalItems = pagination?.total || 0;
    const currentPage = pagination?.page || 1;
    const showPagination = totalPages > 1;

    // Format date for display
    const formatDate = (date) => {
        if (!date) return 'N/A';
        return new Date(date).toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    // Get status badge color
    const getStatusBadge = (status) => {
        const statusMap = {
            'upcoming': { class: 'bg-info', label: 'Upcoming' },
            'ongoing': { class: 'bg-success', label: 'Ongoing' },
            'completed': { class: 'bg-secondary', label: 'Completed' },
            'cancelled': { class: 'bg-danger', label: 'Cancelled' }
        };
        const statusInfo = statusMap[status?.toLowerCase()] || statusMap['upcoming'];
        return <span className={`badge ${statusInfo.class}`}>{statusInfo.label}</span>;
    };

    // Handle status change directly
    const handleStatusChange = async (id, currentStatus) => {
        if (!id) {
            errorToast('Invalid event ID');
            return;
        }

        // Show confirmation
        const statusMap = {
            'upcoming': 'ongoing',
            'ongoing': 'completed',
            'completed': 'cancelled',
            'cancelled': 'upcoming'
        };
        
        const nextStatus = statusMap[currentStatus?.toLowerCase()] || 'upcoming';
        const statusLabels = {
            'upcoming': 'Upcoming',
            'ongoing': 'Ongoing',
            'completed': 'Completed',
            'cancelled': 'Cancelled'
        };

        if (!window.confirm(`Change status from "${statusLabels[currentStatus]}" to "${statusLabels[nextStatus]}"?`)) {
            return;
        }

        try {
            setLoadingId(id);
            const response = await changeStatus(id).unwrap();
            successToast(response?.message || 'Status updated successfully');
            refetch(); // Refresh the list
        } catch (error) {
            console.error('Status change error:', error);
            errorToast(error?.data?.message || 'Failed to change status');
        } finally {
            setLoadingId(null);
        }
    };

    // Handle delete directly
    const handleDelete = async (id, name) => {
        if (!id) {
            errorToast('Invalid event ID');
            return;
        }

        if (!window.confirm(`Are you sure you want to delete "${name || 'this event'}"? This action cannot be undone.`)) {
            return;
        }

        try {
            setLoadingId(id);
            const response = await deleteEvent(id).unwrap();
            successToast(response?.message || 'Event deleted successfully');
            refetch(); // Refresh the list
        } catch (error) {
            console.error('Delete error:', error);
            errorToast(error?.data?.message || 'Failed to delete event');
        } finally {
            setLoadingId(null);
        }
    };

    const handlePageChange = (page) => {
        dispatch(
            setState({
                page: page,
            })
        );
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleSearch = (value) => {
        dispatch(
            setState({
                search: value,
                page: 1,
            })
        );
    };

    const refetchData = () => {
        refetch();
    };

    const handleStatusFilter = (status) => {
        setStatusFilter(status);
        dispatch(
            setState({
                status: status,
                page: 1,
            })
        );
    };

    const clearFilters = () => {
        setStatusFilter('');
        dispatch(
            setState({
                search: '',
                status: '',
                page: 1,
            })
        );
    };

    const handleLimitChange = (e) => {
        const newLimit = parseInt(e.target.value);
        dispatch(
            setState({
                limit: newLimit,
                page: 1,
            })
        );
    };

    const handleRefresh = () => {
        refetch();
        successToast("Data refreshed successfully!");
    };

    if (isLoading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <h5 className="mt-3">Loading Events...</h5>
            </div>
        );
    }

    if (isError) {
        return (
            <div className="text-center py-5">
                <div className="alert alert-danger">
                    <h5>Something Went Wrong</h5>
                    <p>Unable to load Events. Please try again.</p>
                    <button className="btn btn-primary" onClick={handleRefresh}>
                        Retry
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div>
            {/* HEADER */}
            {/* <div className="page-header-breadcrumb all_breadcrumb">
                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
                    <nav>
                        <h4 className="fw-semibold">
                            All Events {totalItems > 0 && <span className="badge-custom bg-primary">{totalItems}</span>}
                        </h4>
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item active">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">All Events</li>
                        </ol>
                    </nav>
                </div>
                <div className="page-title fw-semibold fs-18 mb-0">
                    <button
                        onClick={() => navigate("/add-event")}
                        className="btn btn-primary me-2"
                    >
                        Add Event
                    </button>
                </div>
            </div> */}
<CommonBreadcrumb
    title="All Events"
    count={totalItems}
    breadcrumbs={[
        { label: "Home", link: "/" },
        { label: "All Events" },
    ]}
    buttons={[
        {
            text: "Add Event",
            onClick: () => navigate("/add-event"),
            className: "btn btn-primary",
        },
    ]}
/>
            {/* SEARCH AND FILTER SECTION */}
            <div className="card mb-4">
                <div className="card-body">
                    <div className="row g-3 align-items-center">
                        <div className="col-md-4">
                            <SearchBar
                                search={filter.search}
                                setSearch={handleSearch}
                                placeholder="Search Events by title..."
                            />
                        </div>

                        <div className="col-md-3">
                            <select
                                className="form-select"
                                value={statusFilter}
                                onChange={(e) => handleStatusFilter(e.target.value)}
                            >
                                <option value="">All Status</option>
                                <option value="upcoming">Upcoming</option>
                                <option value="ongoing">Ongoing</option>
                                <option value="completed">Completed</option>
                                <option value="cancelled">Cancelled</option>
                            </select>
                        </div>

                        <div className="col-md-2">
                            <select
                                className="form-select"
                                value={filter.limit}
                                onChange={handleLimitChange}
                            >
                                <option value={5}>5 per page</option>
                                <option value={10}>10 per page</option>
                                <option value={20}>20 per page</option>
                                <option value={50}>50 per page</option>
                                <option value={100}>100 per page</option>
                            </select>
                        </div>

                        <div className="col-md-3 text-md-end">
                            {(filter.search || filter.status) && (
                                <button
                                    className="btn btn-outline-secondary me-2"
                                    onClick={clearFilters}
                                >
                                    <FaTimes className="me-1" />
                                    Clear Filters
                                </button>
                            )}
                            <button
                                className="btn btn-outline-primary"
                                onClick={handleRefresh}
                            >
                                Refresh
                            </button>
                        </div>
                    </div>

                    {(filter.search || filter.status) && (
                        <div className="mt-3 d-flex flex-wrap gap-2">
                            <span className="text-muted me-2">Active Filters:</span>
                            {filter.search && (
                                <span className="badge bg-primary d-flex align-items-center gap-1">
                                    Search: {filter.search}
                                    <button
                                        className="btn btn-link btn-sm text-white p-0 ms-1"
                                        onClick={() => handleSearch('')}
                                    >
                                        <FaTimes />
                                    </button>
                                </span>
                            )}
                            {filter.status && (
                                <span className="badge bg-info d-flex align-items-center gap-1">
                                    Status: {filter.status}
                                    <button
                                        className="btn btn-link btn-sm text-white p-0 ms-1"
                                        onClick={() => handleStatusFilter('')}
                                    >
                                        <FaTimes />
                                    </button>
                                </span>
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* TABLE */}
            <div className="st-wrapper-card">
                {eventData.length === 0 ? (
                    <div className="text-center py-5">
                        <div className="mb-3">
                            <FaCalendar className="text-muted" size={48} />
                        </div>
                        <h5>No Events Found</h5>
                        <p className="text-muted">
                            {filter.search || filter.status
                                ? "Try adjusting your search or filter criteria"
                                : "Click 'Add Event' to create your first event"}
                        </p>
                        {(filter.search || filter.status) && (
                            <button className="btn btn-primary" onClick={clearFilters}>
                                Clear Filters
                            </button>
                        )}
                    </div>
                ) : (
                    <div className="st-table-responsive">
                        <table className="table st-custom-table align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Event Title</th>
                                    <th>Venue</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Status</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {eventData.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>
                                            {(currentPage - 1) * filter.limit + index + 1}
                                        </td>
                                        <td className="fw-semibold">
                                            <div className="d-flex align-items-center gap-2">
                                                {item.image_url && (
                                                    <img
                                                        src={item.image_url}
                                                        alt={item.title}
                                                        style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                                                        className="rounded"
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = '/placeholder-image.png';
                                                        }}
                                                    />
                                                )}
                                                {item.title || 'N/A'}
                                            </div>
                                        </td>
                                        <td>{item.venue || 'N/A'}</td>
                                        <td>{formatDate(item.start_date)}</td>
                                        <td>{formatDate(item.end_date)}</td>
                                        <td>{getStatusBadge(item.status)}</td>
                                        <td className="text-center">
                                            {/* VIEW BUTTON */}
                                            <button
                                                className="st-action-btn st-view-btn me-1"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "view-event",
                                                            title: "View Event",
                                                            data: item,
                                                        })
                                                    )
                                                }
                                                title="View Details"
                                                disabled={loadingId === item.id}
                                            >
                                                <FaEye />
                                            </button>

                                            {/* EDIT BUTTON */}
                                            <button
                                                className="st-action-btn st-edit-btn me-1"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "edit-event",
                                                            title: "Edit Event",
                                                            data: item,
                                                        })
                                                    )
                                                }
                                                title="Edit Event"
                                                disabled={loadingId === item.id}
                                            >
                                                <FaEdit />
                                            </button>

                                            {/* STATUS CHANGE BUTTON - Direct action */}
                                            <button
                                                className="st-action-btn st-status-btn me-1"
                                                onClick={() => handleStatusChange(item.id, item.status)}
                                                title="Change Status"
                                                disabled={loadingId === item.id}
                                            >
                                                {loadingId === item.id ? (
                                                    <span className="spinner-border spinner-border-sm" />
                                                ) : (
                                                    <FaExchangeAlt />
                                                )}
                                            </button>

                                            {/* DELETE BUTTON - Direct action */}
                                            <button
                                                className="st-action-btn st-delete-btn"
                                                onClick={() => handleDelete(item.id, item.title)}
                                                title="Delete Event"
                                                disabled={loadingId === item.id}
                                            >
                                                {loadingId === item.id ? (
                                                    <span className="spinner-border spinner-border-sm" />
                                                ) : (
                                                    <FaTrash />
                                                )}
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {/* PAGINATION */}
                {showPagination && eventData.length > 0 && (
                    <div className="d-flex flex-wrap align-items-center justify-content-between mt-4">
                        <div className="text-muted small mb-2 mb-md-0">
                            Showing {((currentPage - 1) * filter.limit) + 1} to{' '}
                            {Math.min(currentPage * filter.limit, totalItems)} of {totalItems} entries
                        </div>
                        <Pagination
                            page={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                        />
                    </div>
                )}
            </div>
        </div>
    );
}

export default Events;